import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes (but not when only hash changes)
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  useEffect(() => {
    // Handle hash navigation after page loads
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const headerOffset = 100; // Account for fixed header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300); // Delay to ensure page is fully rendered
    }
  }, [hash, pathname]);

  return null;
};

export default ScrollToTop;

